export default "__VITE_ASSET__DEUaG0hL__"